__turbopack_context__.v({
  "bazaarvoice-review-list": "bazaarvoice-review-list-component-module-scss-module__Q6duKa__bazaarvoice-review-list",
});
